import { createAction } from '@ngrx/store';

export const resetStore = createAction('[App] Reset Store');
